/*
 * Mood data — eight calm hues, each tied to a feeling.
 *
 * Lifted from the brand handoff bundle (app/shared.jsx). Used by
 * MoodDot, MoodChip, and the patterns graph in LibraryView.
 *
 * `tone` is a short, non-clinical descriptor — used as a subtitle
 * under the mood name. Per the voice rules: never therapy language.
 */

export interface Mood {
  id: MoodId;
  name: string;
  /** Tailwind utility class (e.g. `bg-m-stressed`). */
  bg: string;
  /** Hex value, for inline styles where Tailwind can't reach. */
  hex: string;
  tone: string;
}

export type MoodId =
  | "calm"
  | "stressed"
  | "confused"
  | "lonely"
  | "tired"
  | "happy"
  | "overthinking"
  | "unmotivated";

export const MOODS: readonly Mood[] = [
  { id: "calm",         name: "Calm",         bg: "bg-m-calm",         hex: "#7FB7B5", tone: "gentle ease" },
  { id: "stressed",     name: "Stressed",     bg: "bg-m-stressed",     hex: "#D97757", tone: "tight in the body" },
  { id: "confused",     name: "Confused",     bg: "bg-m-confused",     hex: "#B89BD9", tone: "unclear, foggy" },
  { id: "lonely",       name: "Lonely",       bg: "bg-m-lonely",       hex: "#5A7CA3", tone: "wanting to be seen" },
  { id: "tired",        name: "Tired",        bg: "bg-m-tired",        hex: "#8C8881", tone: "low battery" },
  { id: "happy",        name: "Happy",        bg: "bg-m-happy",        hex: "#E1A400", tone: "light, warm" },
  { id: "overthinking", name: "Overthinking", bg: "bg-m-overthinking", hex: "#3A6B7E", tone: "looping thoughts" },
  { id: "unmotivated",  name: "Unmotivated",  bg: "bg-m-unmotivated",  hex: "#A8957E", tone: "hard to begin" },
] as const;

export const moodById = (id: MoodId | null | undefined): Mood | undefined =>
  id ? MOODS.find((m) => m.id === id) : undefined;
